import { ATTRIBUTION_FIELDS } from '../interfaces/attribution.interface';
import { ReservationModel } from '../models/reservation.model';
import { ReservationUiModel } from '../ui-models/reservation.ui-model';

function mapToUI(reservationData: ReservationModel): ReservationUiModel {
  return {
    id: reservationData.id,
    checkInDate: reservationData.checkInDate,
    checkOutDate: reservationData.checkOutDate,
    status: reservationData.status,
    primaryGuestName: reservationData.primaryGuestName,
    unitTypeId: reservationData.unitTypeId,
    checkinExpiresAt: reservationData.checkinExpiresAt || 0,
    roomId: reservationData.roomId,
    propertyName: reservationData.propertyName || '',
    source: reservationData.source,
    channel: reservationData.channel,
    // Off the field list, not named one by one -- this mapper is the only path
    // from API shape to view shape, so a field missed here is invisible in the
    // admin whatever the database holds.
    ...ATTRIBUTION_FIELDS.reduce((acc: Record<string, unknown>, field) => {
      const value = (reservationData as unknown as Record<string, unknown>)[field];
      if (value !== undefined && value !== null && value !== '') acc[field] = value;
      return acc;
    }, {}),
    propertyId: reservationData.propertyId || '',
    unitName: reservationData.unitName || '',
    area: reservationData.area || '',
    passKey: reservationData.passKey || '',
    guestIds: reservationData.guestIds || [],
    reservationUrl: reservationData.reservationUrl || '',
    propertyManagersList: reservationData.propertyManagersList,
    createdAt: reservationData.createdAt,
    reservationAdminUrl: reservationData.reservationAdminUrl,
    isValidated: reservationData?.isValidated,
    unitTypeGroupName: reservationData?.unitTypeGroupName,
    totalPaymentAmount: reservationData?.totalPaymentAmount,
    numberOfNights: reservationData?.numberOfNights,
    currency: reservationData?.currency,
    bookingMode: reservationData?.bookingMode,
    modifiedByUsername: reservationData?.modifiedByUsername,
    eventType: reservationData?.eventType,
    roomName: reservationData?.roomName || '-',
    unitInspectedAt: reservationData?.unitInspectedAt,
    unitInspectedByUsername: reservationData?.unitInspectedByUsername,
    unitInspectedById: reservationData?.unitInspectedById,
    unitInspectionRejectedAt: reservationData?.unitInspectionRejectedAt,
    unitInspectionRejectedByUsername: reservationData?.unitInspectionRejectedByUsername,
    unitInspectionRejectedById: reservationData?.unitInspectionRejectedById,
    isUnitInspected: reservationData?.isUnitInspected,
    accessProvisioning: reservationData?.accessProvisioning,
    actualCheckInAt: reservationData?.actualCheckInAt,
    actualCheckOutAt: reservationData?.actualCheckOutAt,
    relatedReservationId: reservationData?.relatedReservationId
  };
}
function mapToUIList(reservationList: ReservationModel[]): ReservationUiModel[] {
  return reservationList.map(mapToUI);
}

export default {
  mapToUI,
  mapToUIList
};
